import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { CartProvider } from "./lib/cart";
import { startLenis, scrollToId } from "./lib/smooth";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Bento } from "./components/Bento";
import { Catalogue } from "./components/Catalogue";
import { Visit } from "./components/Visit";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";

function App() {
  const [active, setActive] = useState("All");

  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  const pick = (cat) => {
    setActive(cat);
    scrollToId("catalogue");
  };

  return (
    <CartProvider>
      <div className="grain min-h-screen bg-white text-[#1C1917]">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Bento onPick={pick} />
          <Catalogue active={active} setActive={setActive} />
          <Visit />
        </main>
        <Footer />
        <CartDrawer />
        <Toaster theme="light" position="bottom-left" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid rgba(214,40,40,0.35)", color: "#1C1917" } }} />
      </div>
    </CartProvider>
  );
}

export default App;
